<template>
  <v-row dense>
    <v-col cols="12">
      <v-text-field
        v-model="form.street"
        :label="`${$t('ADDRESSES.STREET')} *`"
        :rules="getRulesByName('street')"
        :readonly="readonly"
        :disabled="disabled"
        :error-messages="errors.street"
        @input="updateValue('street', $event)"
      />
    </v-col>
    <v-col cols="6">
      <zip-code-input
        v-model="form.zip"
        :readonly="readonly"
        :rules="getRulesByName('zip')"
        :label="`${$t('ADDRESSES.ZIP.ITEM')} *`"
        :disabled="disabled"
        :error-messages="errors.zip"
        @input="updateValue('zip', $event)"
      />
    </v-col>
    <v-col cols="6">
      <v-text-field
        v-model="form.city"
        :label="`${$t('ADDRESSES.CITY')} *`"
        :rules="getRulesByName('city')"
        :disabled="disabled"
        :readonly="readonly"
        :error-messages="errors.city"
        @input="updateValue('city', $event)"
      />
    </v-col>
  </v-row>
</template>

<script>
import { mask } from 'vue-the-mask';
import { notEmpty } from '@/modules/_global/variables/rules.js';
import formEditable from '@/modules/_global/mixins/form-editable';
import ZipCodeInput from '@/modules/_global/_components/zip/ZipCodeInput';

export default {
  name: 'AddressForm',

  components: { ZipCodeInput },

  directives: {
    mask
  },

  mixins: [formEditable],

  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Object,
      default: () => ({ street: [notEmpty], zip: [notEmpty], city: [notEmpty] })
    }
  },

  data: () => ({
    mask: '####',
    form: {}
  })
};
</script>

<style scoped></style>
